import { Injectable } from '@angular/core'
import { LocalStorage } from 'ngx-store'

@Injectable({ providedIn: 'root' })
export class ModernizrService {
  protected required = [
    'websockets', 'canvas', 'fontface', 'history', 'localstorage', 'flexbox']

  satisfied = true
  unsatisfied: string|null = null
  @LocalStorage('ignoreOldBrowser') ignore = false

  constructor () {
    this.satisfied = true
    this.ignore ??= false

    for (const cap of this.required) {
      if (!window['Modernizr'][cap]) {
        this.satisfied = false
        this.unsatisfied = cap
      }
    }
  }

  dismiss (): void {
    this.ignore = true
  }
}
